export const formatArea = (value: string | number | null | undefined): string => {
    if (value === null || value === undefined || value === '') return '';
    const n = Number(value);
    if (Number.isNaN(n)) return String(value);
    return n.toString();
};
